import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=36299dc0&scoped=true&"
import script from "./LicenseCard.vue?vue&type=script&lang=js&"
export * from "./LicenseCard.vue?vue&type=script&lang=js&"
import style0 from "./LicenseCard.vue?vue&type=style&index=0&id=36299dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36299dc0",
  null
  
)

export default component.exports